import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin, interval } from 'rxjs';
import { AppService } from '../../app.service';
import { ModalDialogSeverity } from '../../enums/modal-dialog-severity';
import { ManagedFunctionService } from '../../services/managed-function/managed-function.service';
import { FunctionEditComponent } from '../function-edit/function-edit.component';

@Component({
    selector: 'app-function-search',
    templateUrl: './function-search.component.html',
    styleUrls: ['./function-search.component.css']
})

export class FunctionSearchComponent implements OnInit {

    public creditorsList: any = [];
    public searchParameters: any = null;
    public results: any = null;
    public resultsRecordCount: number = 0;
    public resultsMatTableDataSource: any = null;
    public randomNumber: number = -1;
    public displayedColumns: string[] = ['Avatar', 'Name', 'Type', 'IsDisabled', 'CronTriggerExpression', 'LastStartDateTime', 'LastFinishDateTime', 'Duration', 'IsRunning', 'NextRunDateTime', 'IsDue'];
    public advancedSearchClass: string = 'display-none';
    public resultsClass: string = 'display-none';

    private refreshIntervalMs: any = interval(10000);

    @ViewChild(MatSort) sort: MatSort = new MatSort();
    @ViewChild(MatPaginator) paginator: any;

    public constructor(public appService: AppService, private functionService: ManagedFunctionService, public matDialog: MatDialog) { }

    public ngOnInit(): void {

        this.appService.IsAppBusy = true;

        forkJoin(this.functionService.getDefaultSearchParameters()).subscribe(([searchParameters]) => {

            this.searchParameters = searchParameters;

            this.appService.IsAppBusy = false;
        });
    }

    public toggleAdvancedSearch = (): void => {

        //if (this.advancedSearchClass == 'display-none') {
        //    this.advancedSearchClass = 'display-block';
        //} else {
        //    this.advancedSearchClass = 'display-none';
        //}

        this.appService.showPendingFeatureMessage();
    }

    public search = () => {

        let searchParameters: any = JSON.parse(JSON.stringify(this.searchParameters));          // clone the search parameters as there may be need to manipulate it

        this.appService.IsAppBusy = true;

        this.functionService.search(searchParameters).subscribe((records: any) => {

            if (records != null) {

                this.appService.IsAppBusy = false;

                if (records.length == 0) {

                    this.results = [];
                    this.resultsClass = "display-none";
                    this.resultsRecordCount = 0;
                    this.appService.ShowModalDialog(ModalDialogSeverity.Info, "Empty Search Results", "No data was returned for the criteria.  Check the creditor id, email address and names etc", "OK", "");

                } else {

                    this.resultsClass = "display-block";
                    this.results = records;
                    this.resultsRecordCount = records.length;
                    this.resultsMatTableDataSource = new MatTableDataSource(records);
                    this.resultsMatTableDataSource.sort = this.sort;
                    this.resultsMatTableDataSource.paginator = this.paginator;

                    this.refreshIntervalMs.subscribe((v: any) => {
                        this.randomNumber = Math.random() * 10;
                    });
                }
            }
        });
    }

    public create = (): void => {

        //let route = 'function/0';

        //this.appService.navigateTo(route);

        this.appService.showPendingFeatureMessage();
    }

    public edit = (item: any, isModal: boolean = false) => {

        try {

            if (isModal) {

                const dialogConfig = new MatDialogConfig();

                //dialogConfig.disableClose = false;
                dialogConfig.autoFocus = true;
                dialogConfig.width = "90%";
                dialogConfig.height = "90%";
                dialogConfig.data = item.Id;

                this.matDialog.open(FunctionEditComponent, dialogConfig);

            } else {

                this.appService.navigateTo('function/' + item.ManagedFunctionId);
            }

        } catch (e) {

            this.appService.ShowModalDialog(ModalDialogSeverity.Error, "Error Navigating to Item", "Unable to navigate to user " + item.Id, "OK :(", "");
        }
    }

    public delete = (f: any): void => {

        let proceedResponse = "PROCEED TO DELETE";

        this.appService.ShowModalDialog(ModalDialogSeverity.Warning,
                                        "Confirm Deletion",
                                        "Are you sure you want to delete function " + f.Name + ".  If you are 100% sure, click PROCEEED TO DELETE, otherwise CANCEL",
                                        proceedResponse,
                                        "CANCEL").subscribe((response) => {

            if (response == proceedResponse) {

                this.appService.IsAppBusy = true;

                this.functionService.delete(f.ManagedFunctionId).subscribe((r: any) => {

                    if (r != '') {

                        this.appService.IsAppBusy = false;

                        if (r instanceof HttpErrorResponse) {

                            this.appService.ShowModalDialog(ModalDialogSeverity.Error, "API Error", "An error occurred calling API", "OK", "");

                        } else {

                            // refresh the results grid
                            const itemIndex = this.results.map((i: { Id: any; }) => i.Id).indexOf(f.ManagedFunctionId);

                            if (itemIndex > -1) {

                                this.results.splice(itemIndex, 1);
                            }

                            this.resultsRecordCount = this.results.length;
                            this.resultsMatTableDataSource = new MatTableDataSource(this.results);
                            this.resultsMatTableDataSource.sort = this.sort;
                            this.resultsMatTableDataSource.paginator = this.paginator;
                        }
                    }
                });
            }
        });
    }
}
